import { animate, AnimationTriggerMetadata, style, transition, trigger } from '@angular/animations';


export const APPEARANCE_PREFERENCE_VISIBILITY_ANIMATION: AnimationTriggerMetadata = trigger(
	'appearancePreferenceVisibility',
	[
		transition(':enter', [
			style({
				opacity: 0,
				transform: 'translateY(-0.35rem) scale(0.98)'
			}),
			animate(
				'200ms cubic-bezier(0.2, 0, 0, 1)',
				style({
					opacity: 1,
					transform: 'translateY(0) scale(1)'
				})
			)
		]),
		transition(':leave', [
			style({ pointerEvents: 'none' }),
			animate(
				'160ms cubic-bezier(0.2, 0, 0, 1)',
				style({
					opacity: 0,
					transform: 'translateY(-0.35rem) scale(0.98)'
				})
			)
		])
	]
);
